import React from 'react';
import {Helmet} from 'react-helmet';
import {useDispatch, useSelector} from 'react-redux';
import {hotelsHomeSeoData} from '../redux/selectors';

const HotelsHomeHelmet = () => {
  const {title, meta, link} = useSelector(hotelsHomeSeoData);
  return <Helmet title='myPartner - Hotel Booking' meta={meta} link={link} />;
};

export default HotelsHomeHelmet;
